module.exports = __webpack_public_path__ + "img/9.b50d704b.jpg";